import {
  __,
  el,
  SelectControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editDisplay = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(SelectControl,
    {
      label: __('Selectionner le type d\'affichage de la carte'),
      title: __('Selectionner le type d\'affichage de la carte'),
      className: "select-box",
      options: [
        { label: __('Complet'), value: 'full' },
        { label: __('Carte uniquement'), value: 'onlyMap' }
      ],
      value: attributes.display,
      onChange: (value) => {
        setAttributes({ display: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.add('select-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('select-focused');
        }
      }
    }
  )
}

export { editDisplay }
